import { Option } from "@src/deprecatedDesignSystem/components/ToggleGroup";
import { useMemo } from "react";
import { createEnumParam, useQueryParam, withDefault } from "use-query-params";

export type ViewMode = "small-screens" | "medium-screens" | "full-screen";
export const VIEW_MODE_OPTIONS: Option<ViewMode>[] = [
  { label: "Overview", value: "small-screens", icon: "dots" },
  { label: "Grid view", value: "medium-screens", icon: "grid" },
  { label: "Fullscreen", value: "full-screen", icon: "cards" },
];

type Return = {
  viewMode: ViewMode | null | undefined;
  setViewMode: (value: ViewMode) => void;
};

const useViewModeQueryParams = (): Return => {
  const [viewMode, setViewMode] = useQueryParam(
    "view-mode",
    withDefault(
      createEnumParam(VIEW_MODE_OPTIONS.map((x) => x.value)),
      "medium-screens",
    ),
  );
  return useMemo(() => {
    return { viewMode, setViewMode };
  }, [viewMode, setViewMode]);
};

export default useViewModeQueryParams;
